/**
 * Entidad AccountDomain
 * Representa un dominio personalizado asociado a una cuenta.
 * Permite dominios completos y subdominios, con control de estado y verificación.
 */

export interface AccountDomain {
  id: string;
  accountId: string;
  domain: string; /** Dominio completo (ej: example.com) */
  subdomain?: string;/** Subdominio opcional (ej: shop, blog) */
  isPrimary: boolean; /** Indica si este es el dominio principal de la cuenta */
  preferWww: boolean; /** Preferencia de dominio: true = www.example.com, false = example.com */
  status: AccountDomainStatus; /** Estado del dominio: PENDING, ACTIVE, INACTIVE */
  verifiedAt?: Date; /** Fecha de verificación del dominio */
  
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;
}

export enum AccountDomainStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

 